export const PLATFORM_ROLES = ["platform_owner_super_admin", "platform_owner_admin"];
export const TENANT_ROLES = ["truckstop_owner", "truckstop_admin", "truckstop_staff"];
export const CUSTOMER_ROLES = ["customer_admin", "customer_user"];

export const ROLE_LABELS = {
  platform_owner_super_admin: "Platform Super Admin",
  platform_owner_admin: "Platform Admin",
  truckstop_owner: "Truck Stop Owner",
  truckstop_admin: "Truck Stop Admin",
  truckstop_staff: "Staff",
  customer_admin: "Customer Admin",
  customer_user: "Customer User",
};

export const homeForRole = (role) => {
  if (PLATFORM_ROLES.includes(role)) return "/platform";
  if (TENANT_ROLES.includes(role)) return "/app";
  if (CUSTOMER_ROLES.includes(role)) return "/portal";
  return "/login";
};

// Permission checks (mirror backend for UI hiding)
const STAFF_ALLOW = new Set([
  "order.create", "order.view", "order.complete", "registration.search",
]);
const ADMIN_EXTRA = new Set([
  "user.manage", "settings.manage", "service_type.manage", "customer.manage",
  "order.cancel", "order.attach_customer", "report.view", "audit.view", "message.read",
]);

export const canDo = (role, perm) => {
  if (role === "truckstop_staff") return STAFF_ALLOW.has(perm);
  if (role === "truckstop_admin" || role === "truckstop_owner") {
    return STAFF_ALLOW.has(perm) || ADMIN_EXTRA.has(perm);
  }
  return false;
};
